/* const BASE_URL: string = (import.meta.env.VITE_API_URL as string); */
//const BASE_URL: string = import.meta.env?.VITE_API_URL || "http://localhost:3001";

import getApiUrl from "./ApiUrl.tsx";

const ENDPOINTS = {
    //AUTH_DATA: () => BASE_URL + `/react/init`,
    INIT: () => getApiUrl() + '/react/init',
    LOGIN: () => getApiUrl() + '/login',
    LOGOUT: () => getApiUrl() + '/logout',
    LANDING: () => getApiUrl() + '/landing',
    CATEGORIES: () => getApiUrl() + '/categories',
    CURRENCY: () => getApiUrl() + '/currency',
    SEARCH: (currentLang: string) => `/${currentLang}/search`,
    //ProductPage
    PRODUCT_FETCH: (productName: string) => getApiUrl() + `/product/details/${productName}`,
    NEWSLETTER: () => getApiUrl() + '/product/newsletter',
    //Dashboard
    ORDERS_ACTIVE: () => getApiUrl() + '/orders/active',
    ORDERS_INACTIVE: () => getApiUrl() + '/orders/inactive',
    ORDERS_DETAILS: () => getApiUrl() + '/orders/details',
    TRADERS_SHOW: () => getApiUrl() + '/trader/show',
    TRADER_INFO: () => getApiUrl() + '/trader/info',
    TRADER_ADD: () => getApiUrl() + '/trader/add',
    TRADER_EDIT: () => getApiUrl() + '/trader/edit',
    /* TODO: chyba niepotrzebny traderId w endpoincie */
    TRADER_DETAILS: (traderId: string) => getApiUrl() + `/traders/details/${traderId}`,
    RE_ORDER: () => getApiUrl() + '/orders/reorder',
    RE_ORDER_ADD_PRODUCT: () => getApiUrl() + '/cart/add',
    //Cart
    ADD_PRODUCT: () => getApiUrl() + '/cart/add',
    CLEAR_CART: () => getApiUrl() + `/cart/clear`,
    PRODUCTS_FETCH: () => getApiUrl() + '/cart/products',
    PRODUCTS_UPDATE_QUANTITY: () => getApiUrl() + '/cart/products/changeQuantity',
    PAYMENT_METHODS_FETCH: () => getApiUrl() + '/cart/paymentMethods',
    DELIVERY_METHODS_FETCH: () => getApiUrl() + '/cart/deliveryMethods',
    PLACE_ORDER: () => getApiUrl() + '/cart/end',

    AUTO_COMPLETE_BILLING_ADDRESS: () => getApiUrl() + '/cart/autoComplete',
    VALIDATE_BILLING_ADDRESS: () => getApiUrl() + '/cart/validateBillingAddress',
    VALIDATE_SHIPPING_ADDRESS: () => getApiUrl() + '/cart/validateShippingAddress',
    FETCH_SUMMARY_ORDER: (hash: string) => getApiUrl() + '/cart/summary' + hash,

    UPDATE_RESELLER_ORDER: (orderId: string) => getApiUrl() + '/orders/details/update/' + orderId,
};

export default ENDPOINTS;